// apiClient.ts
import axios from 'axios';
import { requestHandler, errorResponseHandler } from './interceptor';
import { successResponseHandler } from '../axios/interceptors';
import { SERVER_URL } from '../constants';

const axiosWithInterceptor = axios.create({
    baseURL: SERVER_URL,
});

axiosWithInterceptor.interceptors.request.use(requestHandler);
axiosWithInterceptor.interceptors.response.use(successResponseHandler, errorResponseHandler);

export default axiosWithInterceptor;
